export const RATING_FEEDBACK = {
  HIGH: {
    id: 1,
    value: "high"
  },
  MEDIUM: {
    id: 2,
    value: "medium"
  },
  LOW: {
    id: 3,
    value: "low"
  }
};

const { HIGH, LOW, MEDIUM } = RATING_FEEDBACK;

export const O_RATING_FEEDBACK = {
  [HIGH.id]: HIGH,
  [HIGH.value]: HIGH,

  [MEDIUM.id]: MEDIUM,
  [MEDIUM.value]: MEDIUM,

  [LOW.id]: LOW,
  [LOW.value]: LOW
};
